import React from 'react'
import { Routes, Route } from 'react-router-dom'

import WitnessesIndex from './witnesses_index.jsx'
import WitnessesNew from './witnesses_new.jsx'
import WitnessesEdit from './witnesses_edit.jsx'

let WitnessesRouter = () => (
  <Routes>
    <Route exact path="/"         element={ <WitnessesIndex /> } />
    <Route exact path="/new"      element={ <WitnessesNew /> } />
    <Route       path="/:id/edit" element={ <WitnessesEdit /> } />
  </Routes>
)

export default WitnessesRouter
